<template>
	<div>
		<div class="banner-header">
			<div>banner管理</div>
		</div>
		<el-form :inline="true" :model="queryForm">
			<el-form-item label="状态" label-width="60px">
				<el-select v-model="queryForm.status" placeholder="请选择" style="width: 200px">
					<el-option label="全部状态" :value="0"></el-option>
					<el-option label="已发布" :value="2"></el-option>
					<el-option label="草稿" :value="1"></el-option>
					<el-option label="已撤销" :value="9"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="位置类型" label-width="80px">
				<el-select v-model="queryForm.positionType" placeholder="请选择" style="width: 200px">
					<el-option label="全部位置" :value="0"></el-option>
					<el-option label="3.0.0版本之前的发现频道" :value="1"></el-option>
					<el-option label="跑步记录顶部" :value="2"></el-option>
					<el-option label="运动音乐顶部" :value="3"></el-option>
					<el-option label="首页-为你推荐" :value="4"></el-option>
					<el-option label="社区-动态" :value="5"></el-option>
					<el-option label="3.0.0版本及之后的发现频道" :value="6"></el-option>
					<el-option label="问卷调查" :value="7"></el-option>
					<el-option label="首页BANNER" :value="8"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="发布日期" label-width="80px">
				<el-date-picker style="width: 220px" v-model="daterange" type="daterange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="名称" label-width="60px">
				<el-input v-model="queryForm.keyWord" placeholder="搜索名称关键字" style="width: 200px"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="handleQuery">查询</el-button>
				<el-button @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>
		<div class="table-wrapper">
			<div class="pagination">
				<el-button type="primary" size="small" @click="jumpPageBannerDetail('add')">新增</el-button>
				<el-button type="primary" size="small" @click="handleAllRelease">发布</el-button>
				<el-button size="small" @click="handleAllRevocation">撤销</el-button>
				<el-button size="small" @click="handleAllDelete">删除</el-button>
			</div>
			<el-table :data="tableData" style="width: 100%" ref="multipleTable"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column align="center" label="ID" prop="id"></el-table-column>
				<el-table-column inline-template label="BANNER" align="center" width="240">
					<div class="img-wrap">
						<img :src="row.imgUrl" alt="BANNER" />
					</div>
				</el-table-column>
				<el-table-column prop="title" label="名称" align="center" />
				<el-table-column label="适用学校" align="center" inline-template>
					<div>{{ row.applicableCampus ? "部分" : "全部" }}</div>
				</el-table-column>
				<el-table-column prop="clickCount" label="点击量" align="center" />
				<el-table-column label="位置" align="center" inline-template>
					<div>
						<div v-if="row.positionType === 1">3.0.0版本之前的发现频道</div>
						<div v-if="row.positionType === 2">跑步记录顶部</div>
						<div v-if="row.positionType === 3">运动音乐顶部</div>
						<div v-if="row.positionType === 4">首页-为你推荐</div>
						<div v-if="row.positionType === 5">社区-动态</div>
						<div v-if="row.positionType === 6">3.0.0版本及之后的发现频道</div>
						<div v-if="row.positionType === 7">问卷调查</div>
						<div v-if="row.positionType === 8">首页BANNER</div>
					</div>
				</el-table-column>
				<el-table-column label="状态" align="center" inline-template>
					<div>
						<div v-if="row.status === 1">草稿</div>
						<div v-if="row.status === 2">发布</div>
						<div v-if="row.status === 9">撤销发布</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="发布" width="150" align="center">
					<div>
						<div>{{ row.publisher }}</div>
						<div v-if="row.publishTime">
							{{ new Date(row.publishTime).format("yyyy-MM-dd hh:mm:ss") }}
						</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="创建" width="150" align="center">
					<div>
						<div>{{ row.creater }}</div>
						<div>
							{{ new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss") }}
						</div>
					</div>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="150" inline-template>
					<div>
						<template v-if="[1, 9].includes(row.status)">
							<el-button type="text" @click="handleRelease(row)">发布</el-button>
							<el-button type="text" @click="jumpPageBannerDetail('edit',row)">编辑</el-button>
							<el-button type="text" style="color: red" @click="handleDelete(row)">删除</el-button>
						</template>
						<template v-else>
							<el-button type="text" @click="jumpPageBannerDetail('detail',row)">详情</el-button>
							<el-button type="text" style="color: red" @click="handleRevocation(row)">撤销</el-button>
						</template>
					</div>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination :current-page.sync="queryForm.pageNum" :page-size="queryForm.pageSize"
					layout="prev, pager, next, jumper" :total="tableTotal" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			queryForm: {
				status: 0, //  0-全部； 1-草稿； 2-发布 9-撤销发布
				positionType: 0,
				beginAt: "",
				endAt: "",
				keyWord: "",
				pageNum: 1,
				pageSize: 10,
			},
			daterange: [],
			tableData: [],
			tableTotal: 0,
			multipleSelection: []
		};
	},
	mounted() {
		this.handleQuery();
	},
	methods: {
		handleQuery() {
			this.queryForm.beginAt = this.daterange[0]
				? new Date(this.daterange[0]).getTime()
				: "";
			this.queryForm.endAt = this.daterange[1]
				? new Date(this.daterange[1]).getTime()
				: "";
			this.$http({
				url: this.$util.domain + "/adminapi/v3/operate/banner/list",
				method: "POST",
				body: JSON.stringify({
					...this.queryForm,
				}),
			})
				.then((res) => {
					if (res.body.data && JSON.stringify(res.body.data)) {
						const { list, totalCount } = res.body.data;
						this.tableTotal = totalCount || 0;
						if (list && list.length) {
							this.tableData = list;
						} else {
							this.tableData = [];
						}
					} else {
						this.tableTotal = 0;
						this.tableData = [];
					}
				})
				.catch((error) => {
					this.tableTotal = 0;
					this.tableData = [];
				});
		},
		resetQuery() {
			this.daterange = [];
			this.queryForm = {
				status: 0, //  0-全部； 1-草稿； 2-发布 9-撤销发布
				positionType: 0,
				beginAt: "",
				endAt: "",
				keyWord: "",
				pageNum: 1,
				pageSize: 10,
			};
			this.handleQuery();
		},
		/**
		 * 切换页数
		 */
		handleCurrentChange(val) {
			this.queryForm.pageNum = val;
			this.handleQuery();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleAllRelease() {
			const ids = this.multipleSelection.filter(item => {
				return [1, 9].includes(item.status)
			}).map(item => item.id)
			if (ids && ids.length) {
				const params = {
					ids,
					newStatus: 2,
				}
				this.apiPostBannerStatus(params)
			} else {
				this.$util.errorMsg('请选择数据后操作');
			}
		},
		handleRelease(row) {
			const params = {
				id: row.id,
				newStatus: 2,
			}
			this.apiPostBannerStatus(params)
		},
		handleAllRevocation() {
			const ids = this.multipleSelection.filter(item => {
				return ![1, 9].includes(item.status)
			}).map(item => item.id)
			if (ids && ids.length) {
				const params = {
					ids,
					newStatus: 9,
				}
				this.apiPostBannerStatus(params)
			} else {
				this.$util.errorMsg('请选择数据后操作');
			}
		},
		handleRevocation(row) {
			const params = {
				id: row.id,
				newStatus: 9,
			}
			this.apiPostBannerStatus(params)
		},
		apiPostBannerStatus(params) {
			this.$confirm(params.newStatus === 2 ? "确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容" : "确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容", params.newStatus === 2 ? '发布' : '撤销', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$util.domain + "/adminapi/v3/operate/banner/change_status",
					method: "POST",
					body: JSON.stringify({
						...params,
					}),
				}).then(res => {
					console.log(res);
					if (res.body.error === 10000) {
						this.handleQuery();
					} else {
						this.$util.errorMsg(res.body.message || "请联系管理员");
					}
				})
			})
		},

		handleAllDelete() {
			const ids = this.multipleSelection.filter(item => {
				return [1, 9].includes(item.status)
			}).map(item => item.id)
			if (ids && ids.length) {
				const params = {
					ids
				}
				this.apiPostBannerDelete(params)
			} else {
				this.$util.errorMsg('请选择数据后操作');
			}
		},
		handleDelete(row) {
			const params = {
				id: row.id
			}
			this.apiPostBannerDelete(params)
		},
		apiPostBannerDelete(params) {
			this.$http({
				url: this.$util.domain + "/adminapi/v3/operate/banner/delete",
				method: "POST",
				body: JSON.stringify({
					...params,
				}),
			}).then(res => {
				console.log(res);
				if (res.body.error === 10000) {
					this.handleQuery();
				} else {
					this.$util.errorMsg(res.body.message || "请联系管理员");
				}
			})
		},
		jumpPageBannerDetail(type, row) {
			if (type === 'add') {
				this.$router.push({
					path: "/yunying/banner/bannerDetail",
					query: {
						type
					}
				})
			} else {
				this.$router.push({
					path: "/yunying/banner/bannerDetail",
					query: {
						id: row.id,
						type
					}
				})
			}
		}
	},
};
</script>

<style scoped>
.banner-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 36px;
	background-color: #eee;
	font-size: 16px;
	padding: 8px 30px;
	margin: 20px 0;
}

.table-wrapper {
	padding: 12px;
}

.img-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 18px 0;
}

.img-wrap img {
	width: 160px;
	height: 90px;
	object-fit: cover;
}

.pagination {
	text-align: right;
	margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// bannerManage.vue?000e766c